import React from 'react';

import PickAndSpeak2024 from 'views/PickAndSpeak2024';

const BlogNewsroomPage = () => {

return <PickAndSpeak2024/>
};

export default BlogNewsroomPage;